function initFeaturedStory() {
  var $tracks = $('.section-featured-story [data-track]');
  if (!$tracks.length) return;

  $tracks.each(function () {
    var $track = $(this);
    if ($track.hasClass('slick-initialized')) return;
    if ($track.children('.featured-story__slide').length <= 1) return;

    $track.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous"><svg aria-hidden="true" role="img" aria-labelledby="featured-story-prev" xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><title id="featured-story-prev">Featured Story Prev</title><path d="M0.295497 8.07112C-0.0950267 7.6806 -0.0950268 7.04743 0.295497 6.65691L6.65946 0.292945C7.04998 -0.0975789 7.68315 -0.097579 8.07367 0.292945C8.4642 0.68347 8.4642 1.31663 8.07367 1.70716L2.41682 7.36401L8.07367 13.0209C8.4642 13.4114 8.4642 14.0446 8.07367 14.4351C7.68315 14.8256 7.04998 14.8256 6.65946 14.4351L0.295497 8.07112ZM2.33594 7.36401L2.33594 8.36401L1.0026 8.36401L1.0026 7.36401L1.0026 6.36401L2.33594 6.36401L2.33594 7.36401Z" fill="currentColor"/></svg><span hidden="hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next"><svg aria-hidden="true" role="img" aria-labelledby="featured-story-next" xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none"><title id="featured-story-next">Featured Story Next</title><path d="M8.07169 8.07112C8.46221 7.6806 8.46221 7.04743 8.07169 6.65691L1.70773 0.292945C1.31721 -0.0975789 0.68404 -0.097579 0.293516 0.292945C-0.0970081 0.68347 -0.0970082 1.31663 0.293516 1.70716L5.95037 7.36401L0.293515 13.0209C-0.0970092 13.4114 -0.0970093 14.0446 0.293515 14.4351C0.684039 14.8256 1.3172 14.8256 1.70773 14.4351L8.07169 8.07112ZM6.03125 7.36401L6.03125 8.36401L7.36458 8.36401L7.36458 7.36401L7.36458 6.36401L6.03125 6.36401L6.03125 7.36401Z" fill="currentColor"/></svg><span hidden="hidden">Next</span></button>',
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            dots: true
          }
        }
      ]
    });
  });
}

document.addEventListener('DOMContentLoaded', initFeaturedStory);
document.addEventListener('shopify:section:load', initFeaturedStory);
